import {useState, useEffect} from 'react';
import { db, storage } from '../firebase';
import {setDoc, doc, addDoc, collection} from "firebase/firestore";
import {ref, uploadBytesResumable, getDownloadURL} from "firebase/storage";
import {useHistory} from "react-router-dom";

export default function Admin() {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState(0);
    const [category, setCategory] = useState();
    const [img, setImg] = useState();

    async function handleSubmit(e){
        e.preventDefault();
        if(!img) return;

        const fileName = `posts/${new Date().getTime() + img.name}`;
        const storageRef = ref(storage, fileName);
        const uploadTask = uploadBytesResumable(storageRef, img);

        uploadTask.on("state_changed", () =>{}, (err) => console.log(err.code), () => {
            getDownloadURL(uploadTask.snapshot.ref).then(async(url) => {
            let val = "";
            name.split(" ").map((item) => {
                val += item + "-"
            });
            console.log(val);
            setDoc(doc(db, "products", val), {
                name: name,
                category: category,
                description: description,
                img: String(url),
                docName: val,
                price: Number(price)
            }).then(() => {
                alert("Product Added Successfully 💖")
            })
               
            })
        })

    }

  return (
    <>{<div className='admin-page'>
        <form onSubmit={handleSubmit}>
            <h2>Add A New Product</h2>
            <label>Product Name</label>
            <input type= "text" value={name} onChange = {e => setName(e.target.value)}/>
            <label>Product Description</label>
            <textarea value={description} onChange = {e => setDescription(e.target.value)} placeholder = "Each description must be seperated by semi-colons (;)"></textarea>
            <label>Product Price</label>
            <input type= "number" value={price} onChange = {e => setPrice(e.target.value)}/>
            <label>Product Category</label>
            <select defaultValue= "" value={category} onChange = {e => setCategory(e.target.value)}>
                <option disabled value="">---Select Category---</option>
                <option value= "clothes">Clothes</option>
                <option value= "accessories">Accessories</option>
                <option value= "devices">Devices</option>
                <option value="gaming">Gaming</option>
                <option value="supermarket">Supermarket</option>
            </select>
            <label>Product Image</label>
            <input type= "file" onChange={e => setImg(e.target.files[0])}/>
            <button>Submit</button>
        </form>
    </div>}</>
  )
}
